export default "/assets/images/the-mama-to-be-crop.png?06278b0a318bdddec3cfa06519e70381";